// TODO generate this from the backend somehow?
const CLASS_LEVEL_OPTIONS = [
  { value: -101, label: 'Not Applicable', shortLabel: 'N/A' },

  { value: -100, label: 'Unknown', shortLabel: 'UNK' },

  { value: -99, label: 'Unknown (Class 1 or lower)', shortLabel: '<= 1' },

  { value: -1, label: 'Lower Kindergarten', shortLabel: 'LKG' },
  { value: 0, label: 'Upper Kindergarten', shortLabel: 'UKG' },

  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
  { value: 11, label: '11' },
  { value: 12, label: '12' },

  { value: 13, label: 'Unknown (12+)', shortLabel: '12+' },

  { value: 131, label: '3-Year Vocational - Year 1 (V-1/3)', shortLabel: 'V-1/3' },
  { value: 132, label: '3-Year Vocational - Year 2 (V-2/3)', shortLabel: 'V-2/3' },
  { value: 133, label: '3-Year Vocational - Year 3 (V-3/3)', shortLabel: 'V-3/3' },

  { value: 141, label: '4-Year Vocational - Year 1 (V-1/4)', shortLabel: 'V-1/4' },
  { value: 142, label: '4-Year Vocational - Year 2 (V-2/4)', shortLabel: 'V-2/4' },
  { value: 143, label: '4-Year Vocational - Year 3 (V-3/4)', shortLabel: 'V-3/4' },
  { value: 144, label: '4-Year Vocational - Year 4 (V-4/4)', shortLabel: 'V-4/4' },

  { value: 231, label: '3-Year Bachelors - Year 1 (B-1/3)', shortLabel: 'B-1/3' },
  { value: 232, label: '3-Year Bachelors - Year 2 (B-2/3)', shortLabel: 'B-2/3' },
  { value: 233, label: '3-Year Bachelors - Year 3 (B-3/3)', shortLabel: 'B-3/3' },

  { value: 241, label: '4-Year Bachelors - Year 1 (B-1/4)', shortLabel: 'B-1/4' },
  { value: 242, label: '4-Year Bachelors - Year 2 (B-2/4)', shortLabel: 'B-2/4' },
  { value: 243, label: '4-Year Bachelors - Year 3 (B-3/4)', shortLabel: 'B-3/4' },
  { value: 244, label: '4-Year Bachelors - Year 4 (B-4/4)', shortLabel: 'B-4/4' },
];

function getShortenedClassDisplay(classEnum: number): string {
  if (!classEnum) {
    return '';
  }
  const foundLevel = CLASS_LEVEL_OPTIONS.find((option) => option.value === classEnum);
  if (foundLevel && foundLevel.shortLabel) {
    return foundLevel.shortLabel;
  } else if (foundLevel && foundLevel.label) {
    return foundLevel.label;
  } else {
    return classEnum.toString();
  }
}

function getClassDisplay(classEnum: number): string {
  if (!classEnum) {
    return '';
  }
  const foundLevel = CLASS_LEVEL_OPTIONS.find((option) => option.value === classEnum);
  if (foundLevel && foundLevel.label) {
    return foundLevel.label;
  } else {
    return classEnum.toString();
  }
}

export { getShortenedClassDisplay, getClassDisplay, CLASS_LEVEL_OPTIONS };
